import { Divider } from 'src/components/atoms';
import { TextArea } from 'src/components/atoms/TextArea';
import { StyledIcon } from 'src/components/foundations/foundations.styles';
import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
`;

export const CloseIcon = styled(StyledIcon)`
  position: absolute;
  top: 28px;
  left: 20px;
  cursor: pointer;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

export const Name = styled.span`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.body)};
  font-weight: 600;
  line-height: 40px;
`;

export const RowContainer = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
`;

export const StyledDivider = styled(Divider)`
  margin-bottom: 20px;
`;

export const DetailsRowContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 12px;
`;

export const StyledTextArea = styled(TextArea)`
  margin-top: 0;
  margin-bottom: 0;
  resize: none;
  cursor: not-allowed;
  color: rgba(113, 113, 122, 0.7);
`;

export const FooterContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 20px;
  flex-direction: row-reverse;
`;

export const ButtonContainer = styled.div`
  margin-top: 20px;
  align-self: flex-end;
`;

export const DetailsRowWrapper = styled.div`
  margin-bottom: 20px;
`;
